<template>
  <g id="friend">
    <path
      class="cls-3"
      d="M303.8 517.5h34.5a34.5 34.5 0 01-34.5 34.5H131.4a69 69 0 0169-69h137.9a34.5 34.5 0 01-34.5 34.5z"
      transform="translate(17)"
    />
    <path
      class="cls-4"
      d="M226 738.2h17.5a103.5 103.5 0 01103.4 103.5H122.8v-.2A103.3 103.3 0 01226 738.2z"
    />
    <path
      class="cls-35"
      d="M269.6 789.3H166.1a43.1 43.1 0 01-43.1-43.1 43.1 43.1 0 0143.1-43.1h103.5a43.1 43.1 0 0143.1 43.1 43.1 43.1 0 01-43.1 43.1z"
      transform="translate(17)"
    />
    <path
      class="cls-36"
      d="M289.5 734.6a17.4 17.4 0 01-10.7 16.1L252.3 762l-34.6 14.7-34.3-14.6-26.5-11.3a17.7 17.7 0 01-10.7-16.2 17.6 17.6 0 0117.6-17.6h108.1a17.6 17.6 0 0117.6 17.6z"
      transform="translate(17)"
    />
    <path class="cls-6" d="M269.3 701.5V762l-34.6 14.7-34.3-14.6v-60.6h68.9z" />
    <path
      class="cls-20"
      d="M193.4 841.7h-10v-59.9a5 5 0 015-5.1 5 5 0 015 5.1zM252.3 841.7h-10.1v-59.9a5.1 5.1 0 015.1-5.1 5 5 0 015 5.1z"
      transform="translate(17)"
    />
    <g>
      <path
        class="cls-6"
        d="M133.2 593.4h62v44.8h-62a22.4 22.4 0 01-22.4-22.5 22.4 22.4 0 0122.4-22.3zM302.4 593.4H240v44.8h62.4a22.5 22.5 0 0022.5-22.5 22.4 22.4 0 00-22.5-22.3z"
        transform="translate(17)"
      />
    </g>
    <path
      class="cls-5"
      d="M148.4 552h172.4v86.9a86.2 86.2 0 01-86.2 86.2 86.2 86.2 0 01-86.2-86.2V552z"
    />
    <path
      class="cls-19"
      d="M269.3 638.2a53.5 53.5 0 01-2.8 17.2 50.6 50.6 0 01-24.8 28.7 52.8 52.8 0 01-48.5-.2 50.8 50.8 0 01-24.5-28.5 53.5 53.5 0 01-2.8-17.2z"
      transform="translate(17)"
    />
    <path
      class="cls-20"
      d="M269.3 638.2a53.5 53.5 0 01-2.8 17.2h-97.8a53.5 53.5 0 01-2.8-17.2z"
      transform="translate(17)"
    />
    <path
      class="cls-21"
      d="M241.7 684.1a52.8 52.8 0 01-48.5-.2 26 26 0 0148.5.2z"
      transform="translate(17)"
    />
    <path
      class="cls-6"
      d="M234.6 590.4a17.2 17.2 0 0117.2 17.2v16.7h-34.4v-16.6a17.2 17.2 0 0117.2-17.3z"
    />
    <path
      class="cls-10"
      d="M184 603.4a10.4 10.4 0 11-10.4-10.4 10.3 10.3 0 0110.4 10.4zM271.9 603.4a10.4 10.4 0 01-20.7 0 10.4 10.4 0 1120.7 0z"
      transform="translate(17)"
    />
  </g>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>